import jsPDF from "jspdf";
import "jspdf-autotable";
import { ToWords } from "to-words";
import QRCode from "qrcode";
import moment from "moment";
import autoTable from "jspdf-autotable";
import { DOMAIN } from "../../../global";
const UnitechHeader = "../img/IR_Header.png";

let config = {
  margin: 35,
  borderMagin: 7,
  headerHeight: 70,
  footerHeight: 10,
  fontSize: 9,
  cusotmerHeight: 50,
  bordergap: 2,
  currentY: 0,
};
const qrData = (url) => QRCode.toDataURL(url, { margin: 1, width: 120 });

async function renderQRCode(doc, startY, url) {
  if (!url) return startY;

  const h = doc.internal.pageSize.getHeight();
  const w = doc.internal.pageSize.getWidth();
  const size = 60, need = size + 35;

  let y = startY + 10;
  if (y + need > h - config.footerHeight) {
    doc.addPage();
    y = config.margin + config.headerHeight;
  }
  doc.addImage(await qrData(url), "PNG", w - config.margin - size, y, size, size);
  return y + need;
}

function sanitizeInput(value) {
  if (!value) return "";
  return value
    .replace(/\t/g, "")   // remove all tab characters
    .trim();              // remove leading/trailing whitespace
}

function formatDate(value, format = "DD/MM/YYYY") {
  if (value && moment(value).isValid()) {
    return moment(value).format(format);
  }
  return "";
}

// draw border from all sides
const drawMarginRect = (doc) => {
  const totalWidth = doc.internal.pageSize.getWidth();
  const totalHeight = doc.internal.pageSize.getHeight();
  doc.setDrawColor(0);
  doc.setLineWidth(0.5);
  doc.rect(
    config?.borderMagin,
    config?.borderMagin + config?.headerHeight + config.bordergap,
    totalWidth - config?.borderMagin * 2,
    totalHeight -
      config?.borderMagin * 2 -
      (config?.headerHeight + config?.footerHeight) -
      config.bordergap
  );
};

function generateHeaderSection(
  doc,
  inputStates,
  referenceDocsdata,
  attendeesdata,
  itemDetails,
  measuringEquipments,
  tableData
) {
  const pageHeight = doc.internal.pageSize.height - config.footerHeight - config.margin;
  // doc.setFont("helvetica", "bold");
  // doc.setFontSize(12);
  // doc.setTextColor(0, 0, 102);
  // doc.text(
  //   "INSPECTION REPORT",
  //   doc.internal.pageSize.getWidth() / 2,
  //   config?.headerHeight + config?.margin - 5,
  //   { align: "center" }
  // );

  let margins = {
    top: config?.margin + config?.headerHeight - 20,
    left: config.margin,
    right: config.margin,
    bottom: config.margin + config?.footerHeight - 22,
  };

  const totalPageWidth = doc.internal.pageSize.getWidth() - config.margin * 2;
  const columnWidths4Col = [20, 30, 20, 30].map(
    (p) => (totalPageWidth * p) / 100
  );
  // report no to supplier contact name (first 8 row)
  const reportMetadata = [
    ["REPORT NO:", sanitizeInput(inputStates?.reportNo)],
    ["ISSUE DATE:", formatDate(inputStates?.issueDate)],
    ["PROJECT NAME:", sanitizeInput(inputStates?.projectName)],
    [
      "VISIT DATES:",
      inputStates?.visitDate && inputStates?.endvisitDate
        ? `${formatDate(inputStates?.visitDate)} to ${formatDate(
            inputStates?.endvisitDate
          )}`
        : formatDate(inputStates?.visitDate),
    ],
    ["CLIENT:", sanitizeInput(inputStates?.clientId)],
    ["PURCHASE ORDER/REF DOC:", sanitizeInput(inputStates?.purchaseOrder)],
    ["INSPECTOR NAME:", sanitizeInput(inputStates?.inspectedByName)],
    ["CLIENT REFERENCE:", sanitizeInput(inputStates?.clientReference)],
  ];
  const visibleReportFields = reportMetadata.filter(([label, value]) =>
    value?.trim()
  );
  const reportRows = [];
  for (let i = 0; i < visibleReportFields.length; i += 2) {
    const left = visibleReportFields[i];
    const right = visibleReportFields[i + 1] || ["", ""];

    reportRows.push([
      {
        content: left[0],
        styles: {
          fontStyle: "bold",
          fillColor: "#C4D5F2",
          halign: "left",
        },
      },
      { content: left[1] },
      {
        content: right[0],
        styles: {
          fontStyle: "bold",
          fillColor: "#C4D5F2",
          halign: "left",
        },
      },
      { content: right[1] },
    ]);
  }
  reportRows.push(
    [
      {
        content: "SUPPLIER/SUB-SUPPLIER",
        styles: { fontStyle: "bold", fillColor: "#C4D5F2", halign: "left" },
        colSpan: 2,
      },
      {
        content: "INSPECTION SITE ADDRESS",
        styles: { fontStyle: "bold", fillColor: "#C4D5F2", halign: "left" },
        colSpan: 2,
      },
    ],
    [
      {
        content: sanitizeInput(inputStates?.supplierName),
        colSpan: 2,
      },
      {
        content: sanitizeInput(inputStates?.inspectionAddress),
        colSpan: 2,
      },
    ],
    [
      {
        content: "SUPPLIER CONTACT NAME",
        styles: { fontStyle: "bold", fillColor: "#C4D5F2", halign: "left" },
        colSpan: 2,
      },
      {
        content: "SUPPLIER CONTACT NUMBER/EMAIL",
        styles: { fontStyle: "bold", fillColor: "#C4D5F2", halign: "left" },
        colSpan: 2,
      },
    ],
    [
      { content: sanitizeInput(inputStates?.supplierContactName), colSpan: 2 },
      { content: sanitizeInput(inputStates?.supplierContactEmail), colSpan: 2 },
    ]
  );
  let startY = config?.headerHeight + config?.margin - 20;
  autoTable(doc, {
    startY: startY,
    margin: margins,
    body: reportRows,
    theme: "grid",
    styles: {
      fontSize: config.fontSize,
      cellPadding: 5,
      textColor: 0,
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
      valign: "middle",
    },
    columnStyles: {
      0: { cellWidth: columnWidths4Col[0] },
      1: { cellWidth: columnWidths4Col[1] },
      2: { cellWidth: columnWidths4Col[2] },
      3: { cellWidth: columnWidths4Col[3] },
    },
  });

  // item descrption 4 column and dynamic row
  const updatedY = doc.lastAutoTable.finalY;
  const columnWidthsitems = [10, 10, 50, 30].map(
    (p) => (totalPageWidth * p) / 100
  );
  let itemRows = [];
  itemRows.push([
    {
      content: "Sr.No.",
      styles: { fontStyle: "bold", fillColor: "#C4D5F2", halign: "left" },
    },
    {
      content: "Pos.No.",
      styles: { fontStyle: "bold", fillColor: "#C4D5F2", halign: "left" },
    },
    {
      content: "ITEM DESCRIPTION",
      styles: { fontStyle: "bold", fillColor: "#C4D5F2", halign: "left" },
    },
    {
      content: "Remark",
      styles: { fontStyle: "bold", fillColor: "#C4D5F2", halign: "left" },
    },
  ]);

  itemDetails?.forEach((item, index) => {
    itemRows.push([
      { content: index + 1 },
      { content: sanitizeInput(item.posNo) },
      { content: sanitizeInput(item.itemDescription) },
      { content: sanitizeInput(item.remarks) },
    ]);
  });
  autoTable(doc, {
    startY: updatedY,
    margin: margins,
    body: itemRows,
    theme: "grid",
    styles: {
      fontSize: config.fontSize,
      cellPadding: 5,
      textColor: 0,
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
      valign: "middle",
    },
    columnStyles: {
      0: { cellWidth: columnWidthsitems[0] },
      1: { cellWidth: columnWidthsitems[1] },
      2: { cellWidth: columnWidthsitems[2] },
      3: { cellWidth: columnWidthsitems[3] },
    },
  });

  // reference , reviosn 2 column , 6 row
  const referenceDocs = [
    [
      {
        content: "REFERENCE DOCUMENTS (PO / SPECIFICATIONS / ETC.)",
        styles: { fontStyle: "bold", fillColor: "#C4D5F2", halign: "left" },
      },
      {
        content: "REVISION",
        styles: { fontStyle: "bold", fillColor: "#C4D5F2", halign: "left" },
      },
    ],
  ];
  referenceDocsdata?.forEach((item, index) => {
    referenceDocs.push([
      { content: sanitizeInput(item.documents) },
      { content: sanitizeInput(item.revisionNo) },
    ]);
  });
  const columnWidths2Wide = [80, 20].map((p) => (totalPageWidth * p) / 100);
  const refTableStartY = doc.lastAutoTable.finalY;
  autoTable(doc, {
    startY: refTableStartY,
    body: referenceDocs,
    theme: "grid",
    styles: {
      fontSize: config.fontSize,
      cellPadding: 5,
      textColor: 0,
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
    },
    columnStyles: {
      0: { cellWidth: columnWidths2Wide[0] },
      1: { cellWidth: columnWidths2Wide[1] },
    },
    bodyStyles: { valign: "top" },
    margin: margins,
  });

  // Define 3-column layout: Company, Name, Position
  // Section: INSPECTION ACTIVITY and description (full-width rows)

  const colWidths3 = [40, 30, 30].map((p) => (totalPageWidth * p) / 100);
  const startYInspection = doc.lastAutoTable.finalY;
  //  INSPECTION ACTIVITY
  //  1. SCOPE OF VISIT
  const inspectionBody = [
    [
      {
        content: "INSPECTION ACTIVITY",
        colSpan: 3,
        styles: { fontStyle: "bold", fillColor: "#C4D5F2", halign: "left" },
      },
    ],
    [
      {
        content: "1. SCOPE OF VISIT",
        colSpan: 3,
        styles: { fontStyle: "bold", fillColor: "#C4D5F2", halign: "left" },
      },
    ],
    [
      {
        content: sanitizeInput(inputStates?.scopeVisit),
        colSpan: 3,
      },
    ],
    [
      {
        content: "Attendees:",
        colSpan: 3,
        styles: { fontStyle: "bold", fillColor: "#C4D5F2", halign: "left" },
      },
    ],
    [
      {
        content: "Company",
        styles: { fontStyle: "bold", fillColor: "#C4D5F2", halign: "left" },
      },
      {
        content: "Name",
        styles: { fontStyle: "bold", fillColor: "#C4D5F2", halign: "left" },
      },
      {
        content: "Position",
        styles: { fontStyle: "bold", fillColor: "#C4D5F2", halign: "left" },
      },
    ],
  ];
  attendeesdata?.forEach((attendee) => {
    inspectionBody.push([
      { content: sanitizeInput(attendee.company) },
      { content: sanitizeInput(attendee.Name) },
      { content: sanitizeInput(attendee.position) },
    ]);
  });

  // 2. COMPLIANCE ON ENVIRONMENT, HEALTH AND SAFETY
  inspectionBody.push(
    [
      {
        content: "2. COMPLIANCE ON ENVIRONMENT, HEALTH AND SAFETY",
        colSpan: 3,
        styles: { fontStyle: "bold", fillColor: "#C4D5F2", halign: "left" },
      },
    ],
    [
      {
        content: sanitizeInput(inputStates?.comp_Enviroment_HealthSafety),
        colSpan: 3,
      },
    ]
  );
  autoTable(doc, {
    startY: startYInspection,
    margin: margins,
    body: inspectionBody,
    theme: "grid",
    styles: {
      fontSize: config.fontSize,
      cellPadding: 5,
      textColor: 0,
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
    },
    columnStyles: {
      0: { cellWidth: colWidths3[0] },
      1: { cellWidth: colWidths3[1] },
      2: { cellWidth: colWidths3[2] },
    },
  });

  // 3. DETAIL OF INSPECTION:
  const headers = tableData?.header || [];
  const rows = tableData?.body || [];
  const hasTableData = headers.length > 0;
  const totalColumns = hasTableData ? headers.length + 1 : 1;
  const inspectionStartY = doc.lastAutoTable.finalY;  
  const dynamicTableRows = [
    [
      {
        content: "3. DETAIL OF INSPECTION:",
        styles: { fontStyle: "bold", fillColor: "#C4D5F2", halign: "left" },
        colSpan: totalColumns,
      },
    ],
    [
      {
        content: sanitizeInput(inputStates?.inpectionDeatils) || "",
        colSpan: totalColumns,
      },
    ],
  ];
  autoTable(doc, {
    startY: inspectionStartY,
    margin: margins,
    body: dynamicTableRows,
    theme: "grid",
    styles: {
      fontSize: config.fontSize - 1,
      cellPadding: { top: 5, left: 5, right: 23, bottom: 5 },
      textColor: 0,
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
      valign: "middle",
      halign: "left",
    },
  });

  let dynamicstablestartY = doc.lastAutoTable.finalY;
  let tableHead = [];
  let tableBody = [];

  if (hasTableData) {
    // header
    tableHead = [
      [
        {
          content: "Sr.No.",
          styles: { halign: "center", fontStyle: "bold", fillColor: "#C4D5F2" },
        },
        ...headers.map((col) => ({
          content: col.label || "",
          styles: { halign: "center", fontStyle: "bold", fillColor: "#C4D5F2" },
        })),
      ]
    ];
    // Set up body rows
      tableBody = rows.map((row, index) => [
        String(index + 1),
        ...headers.map((col) => String(row[col.colRelation] ?? ""))
      ]);
  }
  const estimatedRowHeight = 20; 
  const requiredHeight = estimatedRowHeight * 2;
  const bottomLimit = margins.bottom || config.margin;
  const available = pageHeight - dynamicstablestartY - bottomLimit;
  if (available < requiredHeight) {
    doc.addPage();
    dynamicstablestartY = margins.top;
  }
  const columnCount = headers.length + 1;
  const adjustedFontSize = Math.max(
  columnCount <= 8 ? config.fontSize :
  columnCount <= 12 ? config.fontSize - 2 :
  columnCount <= 15 ? config.fontSize - 3 :
  config.fontSize - 4, 6
);
  autoTable(doc, {
    startY: dynamicstablestartY,
    margin: margins,
    head: tableHead,
    body: tableBody,
    theme: "grid",
    styles: {
      fontSize: adjustedFontSize,
      cellPadding: { top: 5, left: 5, right: 23, bottom: 5 },
      textColor: 0,
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
      valign: "middle",
      halign: "center",
    },
  });

  const detailInspection = [
    [
      {
        content: "Identification Mark",
        styles: { fontStyle: "bold", halign: "left" },
      },
    ],
    [
      {
        content: sanitizeInput(inputStates?.aiplIdentification),
      },
    ],
    [
      {
        content: "Attachments:",
        styles: { fontStyle: "bold", halign: "left" },
      },
    ],
    [
      {
        content: sanitizeInput(inputStates?.attachments),
      },
    ],
  ];
  let refdetailstartY = doc.lastAutoTable.finalY;
  autoTable(doc, {
    startY: refdetailstartY,
    margin: margins,
    body: detailInspection,
    theme: "grid",
    styles: {
      fontSize: config.fontSize,
      cellPadding: { top: 5, left: 5, right: 23, bottom: 5 },
      textColor: 0,
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
    },
  });

  //  4. DETAIL OF MEASURING/TESTING EQUIPMENT AND CALIBRATION
  const calibrationHeader = [
    [
      {
        content: "4. DETAIL OF MEASURING/TESTING EQUIPMENT AND CALIBRATION",
        colSpan: 5,
        styles: {
          fontStyle: "bold",
          fillColor: "#C4D5F2",
          halign: "left",
        },
      },
    ],
    [
      {
        content: "Sr. No.",
        styles: { fontStyle: "bold", fillColor: "#C4D5F2", halign: "left" },
      },
      {
        content: "INSTRUMENT NAME",
        styles: { fontStyle: "bold", fillColor: "#C4D5F2", halign: "left" },
      },
      {
        content: "INSTRUMENT Sr.No.",
        styles: { fontStyle: "bold", fillColor: "#C4D5F2", halign: "left" },
      },
      {
        content: "CALIBRATION VALIDITY",
        styles: { fontStyle: "bold", fillColor: "#C4D5F2", halign: "left" },
      },
      {
        content: "REMARK",
        styles: { fontStyle: "bold", fillColor: "#C4D5F2", halign: "left" },
      },
    ],
  ];

  const calibrationBody = [];
  measuringEquipments?.forEach((item, index) => {
    calibrationBody.push([
      { content: index + 1 },
      { content: sanitizeInput(item.instrumentName) },
      { content: sanitizeInput(item.instrumentSrNo) },
      { content: formatDate(item.calibrationValidity) },
      { content: sanitizeInput(item.remark) },
    ]);
  });
  const startYCalibration = doc.lastAutoTable.finalY;
  const colWidths5 = [10, 25, 25, 20, 20].map(
    (p) => (totalPageWidth * p) / 100
  );
  autoTable(doc, {
    startY: startYCalibration,
    margin: margins,
    head: calibrationHeader,
    body: calibrationBody,
    theme: "grid",
    styles: {
      fontSize: config.fontSize,
      cellPadding: 5,
      textColor: 0,
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
      valign: "middle",
    },
    columnStyles: {
      0: { cellWidth: colWidths5[0] },
      1: { cellWidth: colWidths5[1] },
      2: { cellWidth: colWidths5[2] },
      3: { cellWidth: colWidths5[3] },
      4: { cellWidth: colWidths5[4] },
    },
  });

  // 5.PUNCH LIST
  const punchListHeader = [
    [
      {
        content: "5. PUNCH LIST",
        colSpan: 5,
        styles: {
          fontStyle: "bold",
          fillColor: "#C4D5F2",
          halign: "left",
        },
      },
    ],
  ];
  const punchListBody = [
    [
      {
        content: sanitizeInput(inputStates?.punchList || ""),
        colSpan: 5,
      },
    ],
  ];
  let startYPunchList = doc.lastAutoTable?.finalY || startYCalibration + 10;
  const estimatedPunchListHeight = 40;
  if (startYPunchList + estimatedPunchListHeight > pageHeight) {
    doc.addPage();
    startYPunchList = margins.top;
  }
    autoTable(doc, {
      startY: startYPunchList,
      margin: margins,
      head: punchListHeader,
      body: punchListBody,
      theme: "grid",
      styles: {
        fontSize: config.fontSize,
        cellPadding: 5,
        textColor: 0,
        lineWidth: 0.1,
        lineColor: [0, 0, 0],
        valign: "middle",
      },
      columnStyles: {
        0: { cellWidth: totalPageWidth }, // Full width
      },
    });
  }

// Helper function to draw the header and footer images
function addHeaderFooter(doc) {
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const marginX = config.margin - 11;
  const headerHeight = config?.headerHeight;
  let letterHead = UnitechHeader;
  // Calculate new width for the header image with margins
  const headerWidth = pageWidth - marginX * 2;
  // Draw header image with left/right margins
  doc.addImage(letterHead, "PNG", marginX, 0, headerWidth - 2, headerHeight);
  // Optional: Footer logic (commented out in your code)
  // const footerHeight = config?.footerHeight || 30;
  // doc.addImage(UnitechFooter, "PNG", marginX, pageHeight - footerHeight, headerWidth, footerHeight);
}
function toDataURL(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.setAttribute("crossOrigin", "anonymous");
    img.onload = function () {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL("image/jpeg"));
    };
    img.onerror = function (err) {
      reject(err);
    };
    img.src = url;
  });
}

async function renderUploadedImagesSection(doc, uploadedImages, startY) {
  const imagesOnly = uploadedImages?.filter((file) =>
    file.imagePath?.match(/\.(jpeg|jpg|png|gif|bmp)$/i)
  );

  if (!imagesOnly?.length) return;

  const imgGapXY = 5;
  const imageWidth = 245;
  const imageHeight = 115;
  const gap = 20;
  const pageWidth = doc.internal.pageSize.getWidth();
  let x = config.margin + imgGapXY;
  let y = startY + 20;
  const firstImageRequiredHeight = imageHeight + 30 + config.footerHeight + 20;
  const pageHeight = doc.internal.pageSize.getHeight();
  const availableHeight = pageHeight - y - config.footerHeight;

  // If heading + first image won't fit, add a new page
  if (availableHeight < firstImageRequiredHeight) {
    doc.addPage();
    y = config.margin + config.headerHeight - 15;
  }
  let sectionTopY = y - 10;
  let borderStartY = sectionTopY - 5;
  let maxBorderBottomY = borderStartY;
  
  // const leftX = config.margin + 2; // Slightly wider left margin
  // const rightX = pageWidth - config.margin -2; // Slightly wider right margin
  // let sectionTopY = y - 10;
  // let borderStartY = sectionTopY - 5;
  // let maxBorderBottomY = borderStartY;
  let showHeading = true;
  let rowImages = []; // Track images in current row
  if (showHeading) {
    const headingText = "6.PHOTOS";
    const fontSize = config.fontSize;
    const marginLeft = config.margin;
    const marginRight = config.margin;
    const pageWidth = doc.internal.pageSize.getWidth();
    const usableWidth = pageWidth - marginLeft - marginRight;

    const headingPaddingY = 6; // vertical padding inside heading box
    const posY = sectionTopY; // Add top space here
    const rectY = posY - fontSize; // Start rectangle above text line
    // Background + border
    doc.setFillColor(196, 213, 242);
    doc.setDrawColor(0);
    doc.rect(marginLeft, rectY, usableWidth, fontSize + headingPaddingY, "FD");
    // Draw text with a little inner padding
    doc.setFont("helvetica", "bold");
    doc.setFontSize(fontSize);
    doc.setTextColor(0, 0, 0);
    doc.text(headingText, marginLeft + 2, posY);
    // Increase `y` position after heading to give space before images
    y = posY + headingPaddingY + 5;
    showHeading = false;
  }

  for (let i = 0; i < imagesOnly.length; i++) {
    const { imagePath, imagesName } = imagesOnly[i];

    try {
      const imgData = await toDataURL(imagePath);
      const requiredHeight = imageHeight + 30 + config.footerHeight;
      const availableHeight =
        doc.internal.pageSize.getHeight() - y - config.footerHeight;

      if (availableHeight < requiredHeight) {
        // Draw border on previous page
        // doc.setDrawColor(0);
        // doc.setLineWidth(0.5);
        // doc.rect(leftX, borderStartY, rightX - leftX, maxBorderBottomY - borderStartY + 20);

        // Add new page
        doc.addPage();
        x = config.margin + imgGapXY;
        y = config.margin + config.headerHeight - 15;
        borderStartY = y - 10;
        maxBorderBottomY = borderStartY;
      }

      // Draw image
      doc.addImage(imgData, "JPEG", x, y, imageWidth, imageHeight);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(config.fontSize - 1);
      doc.text(imagesName || "-", x, y + imageHeight + 15);

      // Track this image for border drawing
      rowImages.push({x, y, width: imageWidth, height: imageHeight, name: imagesName});

      // Update max Y for border
      maxBorderBottomY = Math.max(maxBorderBottomY, y + imageHeight + 15);
      // Check if this is the first image in a row (left side)
      const isFirstInRow = x === config.margin + imgGapXY;
      // Move to next column or row
      if (x + imageWidth * 2 + gap < pageWidth - config.margin) {
        x += imageWidth + gap + imgGapXY;
      } else {
        // End of row - draw borders around the row images
        drawRowBorder(doc, rowImages, gap, imgGapXY);
        rowImages = []; // Reset for next row
        x = config.margin + imgGapXY;
        y += imageHeight + 30;
      }
    } catch (err) {
      console.warn("Unable to load image:", imagePath, err);
    }
  }

  // Draw border for the last row if it has images
  if (rowImages.length > 0) {
    drawRowBorder(doc, rowImages, gap, imgGapXY);
  }

  return maxBorderBottomY + 2;
}

// Helper function to draw borders around a row of images
function drawRowBorder(doc, rowImages, gap, imgGapXY) {
  if (rowImages.length === 0) return;
  
  const borderPadding = 5;
  const nameHeight = 20;
  
  // Calculate overall border dimensions
  const firstImg = rowImages[0];
  const lastImg = rowImages[rowImages.length - 1];
  
  const borderLeft = firstImg.x - borderPadding;
  const borderTop = firstImg.y - borderPadding;
  const borderRight = lastImg.x + lastImg.width + borderPadding;
  const borderBottom = firstImg.y + firstImg.height + nameHeight + borderPadding;
  
  const borderWidth = borderRight - borderLeft;
  const borderHeight = borderBottom - borderTop;
  
  // Draw outer border
  doc.setDrawColor(0);
  doc.setLineWidth(0.5);
  doc.rect(borderLeft, borderTop, borderWidth, borderHeight);
  
  // Draw vertical divider between images (if more than 1 image)
  if (rowImages.length > 1) {
    const dividerX = firstImg.x + firstImg.width + (gap + imgGapXY) / 2;
    doc.line(dividerX, borderTop, dividerX, borderBottom);
  }
}

  async function renderSignaturesSection(
    doc,
    startY,
    inputStates,
    inspectedBySign,
    inspectedByName,
    approvedBySign,
    approvedByName
  ) {
    const pageHeight = doc.internal.pageSize.getHeight();
    const pageWidth = doc.internal.pageSize.getWidth();
    const leftX = config.margin + 2;
    const rightX = pageWidth - config.margin - 2;
    const sectionWidth = rightX - leftX;

    const centerX = leftX + sectionWidth / 2;

    const signImgWidth = 120;
    const signImgHeight = 60;
    const nameFontSize = config.fontSize - 1;
    const gapY = 30;
    const textSpacing = 15;

    let signStartY = startY + gapY;
    const expectedHeight = gapY + signImgHeight + textSpacing * 3 + 20;
    const spaceLeft = pageHeight - startY;
    
    // Add new page if not enough space
    if (spaceLeft < expectedHeight) {
      doc.addPage();
      signStartY = config.margin + config.headerHeight;
    }
    
    const sectionTopY = signStartY - 10;
    let maxY = signStartY;

    // Draw signatures
    try {
      if (inspectedBySign) {
        const inspectedSign = await toDataURL(inspectedBySign);
        doc.addImage(
          inspectedSign,
          "JPEG",
          leftX + 10,
          signStartY,
          signImgWidth,
          signImgHeight
        );
      }
    } catch (e) {
      console.warn("Failed to load inspectedBySign", e);
    }

    try {
      if (approvedBySign) {
        const approvedSign = await toDataURL(approvedBySign);
        doc.addImage(approvedSign, "JPEG", rightX - signImgWidth - signImgWidth - 5, signStartY, signImgWidth, signImgHeight);
      }
    } catch (e) {
      console.warn("Failed to load approvedBySign", e);
    }

    // Names under signatures
    doc.setFont("helvetica", "bold");
    doc.setFontSize(nameFontSize);

    const inspectedNameY = signStartY + signImgHeight + 15;
    const approvedNameY = signStartY + signImgHeight + 15;

    //Left Side (Inspector)
    doc.text("(Sign & Name of the Inspector/Surveyor with Stamp)", leftX + 10, inspectedNameY);
    doc.text(inspectedByName || "-", leftX + 10, inspectedNameY + textSpacing);
    doc.text(`Date: ${formatDate(inputStates?.issueDate)}`, leftX + 10, inspectedNameY + textSpacing * 2);

    //Right Side (Reviewer) – LEFT aligned
    const reviewerX = centerX + 10;
    doc.text("(Name & Signature of the Reviewer)", reviewerX, approvedNameY);
    doc.text(approvedByName || "-", reviewerX, approvedNameY + textSpacing);
    doc.text(`Date: ${formatDate(inputStates?.issueDate)}`,
      reviewerX,
      approvedNameY + textSpacing * 2
    );
    
    const qrSize = 55; // Define QR code size
    try {
    const qrData = await QRCode.toDataURL(`${DOMAIN}/#/inspectionReport/print/qr/${inputStates?.id}`, { margin: 1, width: 120 });
    const qrX = rightX - qrSize - 10;
    const qrY = signStartY + qrSize;
    doc.addImage(qrData, "PNG", qrX, qrY, qrSize, qrSize);
  } catch (e) {
    console.warn("Failed to generate QR code", e);
  }

  maxY = Math.max(
    inspectedNameY + textSpacing * 2,
    approvedNameY + textSpacing * 2,
    signStartY + qrSize 
  );

  // Draw outer border
  const borderHeight = maxY - sectionTopY + 10;
  doc.setDrawColor(0);
  doc.setLineWidth(0.5);
  doc.rect(leftX, sectionTopY, sectionWidth, borderHeight);

  // Draw center divider
  doc.line(centerX, sectionTopY, centerX, sectionTopY + borderHeight);

  return sectionTopY + borderHeight;
}

export async function generateInspectionReportPrint(
  inputStates,
  referenceDocsdata,
  attendeesdata,
  itemDetails,
  measuringEquipments,
  uploadedImages,
  tableData,
  setDownloadPdfloading,
) {
  try {
    setDownloadPdfloading(true);  
  const doc = new jsPDF({
    orientation: "p",
    unit: "pt",
    format: "a4",
    compress: true,
  });

  // Generate the content
  generateHeaderSection(doc,inputStates,referenceDocsdata,attendeesdata,itemDetails,measuringEquipments,tableData?.[0]);

  const imageSectionBottomY = await renderUploadedImagesSection(doc, uploadedImages, doc.lastAutoTable.finalY || 100);

 const signimgy =  await renderSignaturesSection(
    doc,
    uploadedImages.length > 0 ? imageSectionBottomY  : doc.lastAutoTable.finalY,
    inputStates,
    inputStates.inspectedBySign,
    inputStates.inspectedByName,
    inputStates.approvedBySign,
    inputStates.approvedByName
  );

  // await renderQRCode( doc, signimgy, `${DOMAIN}/#/inspectionReport/print/qr/${inputStates?.id}`);

  const totalPages = doc.getNumberOfPages();
  for (let page = 1; page <= totalPages; page++) {
    doc.setPage(page);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(config.fontSize - 2);
    doc.setTextColor(0);
    let pageWidth = doc.internal.pageSize.getWidth();
    let pageHeight = doc.internal.pageSize.getHeight();
    let y = pageHeight - config.footerHeight + 2; // Bottom position

    // Left-side text
    let leftText = `Page No : ${String(page).padStart(2, "0")} of ${String(
      totalPages
    ).padStart(2, "0")}`;
    doc.text(
      leftText,
      config.margin + 10, // Align left side with margin
      y
    );
    // Right-side text (page number)
    let rightText = "FormatNo.BFI/FM/INSP/IR/1,Rev-5,Rev.Date:20.05.2024";
    doc.text(rightText, pageWidth - config.margin - 200, y, { align: "left" });

    // drawMarginRect(doc);
  }

  //   if (letterHead) {
  const pageCount = doc.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    addHeaderFooter(doc);
    //   }
  }
  doc.save(`inspection.pdf`);
   setDownloadPdfloading(false);    
  } catch (error) {
    setDownloadPdfloading(false);
    console.log("pdf genrating error", error)
  }
}
